import SendIcon from '@mui/icons-material/Send';
import MailOutlineIcon from '@mui/icons-material/MailOutline';

const ContactUs = () => {
    return (
        <div className="bg-[#f9fbfd] min-h-screen flex flex-col items-center px-4 py-12">

            <h2 className="lg:text-[48px] font-[500] text-[#333] text-left self-start">
                Contact Us
            </h2>


            <div className="rounded-xl  w-full max-w-md">
                <div className="flex flex-col items-center mb-6">
                    <MailOutlineIcon
                        className="text-blue-600 mb-3"
                        style={{ height: '120px', width: '120px' }}
                    />
                    <p className="text-[400] lg:text-[24px] text-[#666] text-center">
                        Feel free to reach out us with<br /> any questions or inquiries.
                    </p>
                </div>


                <form className="bg-[#F0F4F9] p-4 lg:px-[24px] lg:py-[32px] rounded-[24px] space-y-4">
                    <div>
                        <label className="text-sm font-[500] lg:text-[14px] text-[#333]">Name</label>
                        <input
                            type="text"
                            placeholder="Enter name"
                            className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>
                    <div>
                        <label className="text-sm font-[500] lg:text-[14px] text-[#333]">Email</label>
                        <input
                            type="email"
                            placeholder="Enter email id"
                            className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>
                    <div>
                        <label className="text-sm font-[500] lg:text-[14px] text-[#333]">Subject</label>
                        <input
                            type="text"
                            placeholder="Enter subject"
                            className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>
                    <div>
                        <label className="text-sm font-[500] lg:text-[14px] text-[#333]">Message</label>
                        <textarea
                            placeholder="Enter message"
                            rows="3"
                            className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        ></textarea>
                    </div>

                 
                    <button
                        type="submit"
                        className="flex items-center justify-center gap-2 bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition"
                    >
                        <SendIcon fontSize="small" />
                        Send
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ContactUs;
